








































import Vue from 'vue'
import { SearchFacets } from '@/search/types'
import cloneDeep from 'lodash/cloneDeep'


export enum GENDERS {
  ALL = '',
  MEN = 'men',
  WOMEN = 'women',
  UNISEX = 'unisex',
  KID = 'kid'
}

export default Vue.extend({
  props: {
    searchFacet: {
      type: Object as () => SearchFacets,
      required: true
    },
    value: {
      type: String,
      default: GENDERS.ALL
    }
  },
  data(): {
    selectedTab: string
  }{
    return {
      selectedTab: cloneDeep(this.value)
    }
  },
  computed: {
    GENDERS() {
      return GENDERS
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
          this.selectedTab = newVal
        }
      }
    }
  },
  methods: {
    isSelected(value: string): boolean {
      return this.selectedTab === value
    },
    getTabIcon(value: string): string {
      return require(`common/search/icon-${value}.svg`)
    },
    onTabChange(value: string) {
      if (value !== this.selectedTab) {
        this.$emit('onTabChange', {
          oldValue: this.selectedTab,
          newValue: value
        })
        this.selectedTab = value
      }
    }
  }
})
